 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A877760448125672173_2574980TXT from '@/components/7877760448125672173_25749-8-0.txt'
 import A877760448125672173_2574981TXT from '@/components/7877760448125672173_25749-8-1.txt'
 import A877760448125672173_2574982TXT from '@/components/7877760448125672173_25749-8-2.txt'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/7877760448125672173_25749-8-0.txt",
 			"name" : "7877760448125672173_25749-8-0.txt",
 			"component" : A877760448125672173_2574980TXT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js